import { Directus } from '@directus/sdk';
import { API_DIGITAL_GROW_FIELDS, API_MISSION_FIELDS, API_OBJECTIVES_FIELDS, API_STRATEGY_FIELDS, API_TEAM_FIELDS, API_ANNUAL_REPORT_FIELDS } from './fields';
import { About } from './models/About';
export default class AboutAPI {
    static getInstance(basePath) {
        if (this.instance)
            return this.instance;
        if (!basePath) {
            basePath = process.env.CMS_URL;
        }
        const instance = new AboutAPI();
        instance.api = new Directus(basePath);
        return (this.instance = instance);
    }
    async getAboutCollection(lang) {
        var _a;
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items('homepage').readOne(1, {
            fields: [
                ...API_OBJECTIVES_FIELDS,
                ...API_MISSION_FIELDS,
                ...API_TEAM_FIELDS,
                ...API_STRATEGY_FIELDS,
                ...API_DIGITAL_GROW_FIELDS,
                ...API_ANNUAL_REPORT_FIELDS
            ],
            deep: {
                mission: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                objectives: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                    items: {
                        objectives_items_id: {
                            translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                        }
                    }
                },
                strategy: {
                    strategy_items: {
                        strategy_items_id: {
                            translations: {
                                _filter: { languages_code: { lang: { _eq: lang } } }
                            }
                        }
                    },
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                team: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                digitalgrow: {
                    projects: {
                        project_id: {
                            translations: {
                                _filter: { languages_code: { lang: { _eq: lang } } }
                            }
                        }
                    },
                    assistance_metrics: {
                        digital_grow_metrics_id: {
                            translations: {
                                _filter: { languages_code: { lang: { _eq: lang } } }
                            }
                        }
                    },
                    formation_metrics: {
                        digital_grow_metrics_id: {
                            translations: {
                                _filter: { languages_code: { lang: { _eq: lang } } }
                            }
                        }
                    },
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                annual_report: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                    annual_report_items: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                    }
                }
            }
        }));
        return About.fromApi(response);
    }
}
